module.exports = " <div> <div ng-include=\"'customStyle'\"></div> <div ng-include=\"'header-project'\"></div> <div ng-include=\"'projects-list'\"></div> <div ng-include=\"'project-details'\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/research/projects/list/projectsList.html
// module id = 614
// module chunks = 0